export const pagingHelper = (totalContents: number, size: number): number => {
  const total = Math.ceil(totalContents / size)
  if (total < 1) {
    return 1
  }
  return total
}
export default pagingHelper
